import { Component } from '@angular/core';
import {ReorderDialogComponent} from "@spartacus/order/components";
import {OCC_CART_ID_CURRENT, RoutingService} from "@spartacus/core";
import {LaunchDialogService} from "@spartacus/storefront";
import {ReorderOrderFacade} from "@spartacus/order/root";
import {MultiCartFacade} from "@spartacus/cart/base/root";

@Component({
  selector: 'app-gonvarri-reorder',
  templateUrl: './gonvarri-reorder.component.html',
  styleUrl: './gonvarri-reorder.component.scss',
  standalone: false
})
export class GonvarriReorderComponent extends ReorderDialogComponent {

  constructor(
    launchDialogService: LaunchDialogService,
    reorderOrderFacade: ReorderOrderFacade,
    multiCartFacade: MultiCartFacade,
    private routingService: RoutingService
  ) {
    super(launchDialogService, reorderOrderFacade, multiCartFacade);
  }

  override createCartFromOrder(orderCode: string): void {
    this.showDecisionPrompt$.next(false);
    this.loading$.next(true);
    this.reorderOrderFacade
      .reorder(orderCode)
      .subscribe((cartModificationList) => {
        this.multiCartFacade.reloadCart(OCC_CART_ID_CURRENT);
        this.routingService.goByUrl("/checkout/payment-type").then(() => {
          this.cartModifications = cartModificationList.cartModifications;
          this.loading$.next(false);
          this.recaptureFocus();
          this.close('Finished the creation proccess of the order');
          document.querySelector('app-gonvarri-reorder')?.remove();
        });
      });
  }

}
